module.exports = __webpack_public_path__ + "img/search.7b39161.png";